import { render, staticRenderFns } from "./after.vue?vue&type=template&id=6c45a8f6&scoped=true&"
import script from "./after.vue?vue&type=script&lang=js&"
export * from "./after.vue?vue&type=script&lang=js&"
import style0 from "./after.vue?vue&type=style&index=0&id=6c45a8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c45a8f6",
  null
  
)

export default component.exports